export default __webpack_public_path__ + "96178824b6fe8d2335b55b2fe987d73e.png";